import { Box, Flex } from '@televet/kibble-ui';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Text } from '@televet/kibble-ui/build/components/Text';
import partial from 'lodash-es/partial';
import React from 'react';
import { ChatEntityType } from '../enums/ChatEntityType';
import { AppointmentData } from '../types/AppointmentData';
import { AppointmentListItem } from './AppointmentListItem';

type AppointmentListProps = {
  title: string;
  appointments: AppointmentData[];
  handleChatEntitySelect: (id: string, type: ChatEntityType) => void;
};

export const AppointmentList = ({ title, appointments, handleChatEntitySelect }: AppointmentListProps): JSX.Element => {
  return (
    <Box overflow="auto">
      <Heading size="sm" mb={4} mx={1}>
        {title}
      </Heading>
      <Flex direction="column" mx={1}>
        {appointments.length ? (
          appointments.map((appointmentData) => (
            <AppointmentListItem
              key={appointmentData.id}
              appointmentData={appointmentData}
              onClick={partial(handleChatEntitySelect, appointmentData.id, ChatEntityType.Appointment)}
            />
          ))
        ) : (
          <Text size="sm">This client has no {title.toLowerCase()} appointments</Text>
        )}
      </Flex>
    </Box>
  );
};
